import gql from 'graphql-tag';

export const leadListGql = gql`
  query (
    $inst_id: String!
    $account_id: String!
    $filters: String
    $sort: String!
    $search: String!
    $page: Int
    $size: Int
    $myListsOnly: Boolean!
  ) {
    paginatedList(
      instId: $inst_id
      accountId: $account_id
      filters: $filters
      sort: $sort
      search: $search
      page: $page
      size: $size
      myListsOnly: $myListsOnly
    ) {
      list {
        userKeyConsolidated: id
        createdAt
        lastModified: updatedAt
        deletedAt
        name
        instId
        accountId
        system
        privacy: shared
        filters
        orderBy
        attributes
        createdBy: createUser
        updateUser
        listType
        leads: count
      }
      page
      totalPages
      totalRecords
      recordsPerPage
      prevPage
      nextPage
    }
  }
`;

export const updateListGql = gql`
  mutation (
    $inst_id: String!
    $account_id: String!
    $id: String!
    $name: String!
    $audiencesSearch: String
  ) {
    listUpdate(
      instId: $inst_id
      accountId: $account_id
      id: $id
      name: $name
      audiencesSearch: $audiencesSearch
    ) {
      data {
        count
        updatedAt
        id
        accountId
        system
        shared
        name
        deletedAt
        orderBy
        attributes
      }
      message
      code
    }
  }
`;

export const updateIndividualListGql = gql`
  mutation (
    $inst_id: String!
    $account_id: String!
    $copy_from_id: String!
    $copy_to_id: String!
    $audiencesSearch: String
  ) {
    listAudienceMerge(
      copyFromId: $copy_from_id
      copyToId: $copy_to_id
      instId: $inst_id
      accountId: $account_id
      audiencesSearch: $audiencesSearch
    ) {
      data {
        updatedAt
        id
        accountId
        system
        shared
        name
        deletedAt
        orderBy
        attributes
        count
      }
      message
      code
    }
  }
`;

export const deleteListGql = gql`
  mutation ($inst_id: String!, $account_id: String!, $id: String!) {
    listDelete(instId: $inst_id, accountId: $account_id, id: $id) {
      data {
        updatedAt
        id
        accountId
        system
        shared
        name
        deletedAt
        orderBy
        attributes
      }
      message
      code
    }
  }
`;

export const createListGql = gql`
  mutation (
    $inst_id: String!
    $account_id: String!
    $filters: FilterExpressionInput
    $name: String
    $createUser: String
    $listType: ListTypeEnum!
    $audiencesSearch: String
  ) {
    listCreate(
      createUser: $createUser
      instId: $inst_id
      accountId: $account_id
      filters: $filters
      name: $name
      listType: $listType
      audiencesSearch: $audiencesSearch
    ) {
      data {
        count
        updatedAt
        id
        accountId
        system
        shared
        name
        deletedAt
        orderBy
        attributes
      }
      message
      code
    }
  }
`;

export const appendUsersToListGql = gql`
  mutation (
    $inst_id: String!
    $account_id: String!
    $id: String!
    $profiles: [ListAudienceAppendInput!]!
  ) {
    listAudienceAppendIds(
      accountId: $account_id
      instId: $inst_id
      id: $id
      profiles: $profiles
    ) {
      message
      data {
        count
        listType
        name
      }
    }
  }
`;

export const duplicateListGql = gql`
  mutation (
    $inst_id: String!
    $account_id: String!
    $id: String!
    $name: String!
    $audiencesSearch: String
  ) {
    listDuplicate(
      instId: $inst_id
      accountId: $account_id
      id: $id
      name: $name
      audiencesSearch: $audiencesSearch
    ) {
      data {
        updatedAt
        id
        accountId
        system
        shared
        name
        deletedAt
        orderBy
        attributes
        count
      }
      message
      code
    }
  }
`;
